import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import Pulse from 'react-reveal/Pulse'

import { SectionContainer, SectionTitle, SectionText, CTA } from '../../_common'
import { Grid } from '@material-ui/core'

import useStyles from './styles'
import { FaPlay } from 'react-icons/fa'

const getInfo = graphql`
  {
    usImg: file(relativePath: { eq: "homepage-us.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Us = () => {
  const { wrapper, image, imgContainer } = useStyles()
  const { usImg } = useStaticQuery(getInfo)

  return (
    <SectionContainer sectionID="us">
      <Grid container className={wrapper}>
        <Grid item sm={6} container className={imgContainer}>
          <Img
            className={image}
            fluid={usImg.childImageSharp.fluid}
            alt="global-actuarial-services-nosotros"
          />
        </Grid>
        <Grid item sm={6}>
          <SectionTitle title="Quiénes somos" />
          <SectionText text="Con más de 50 años de experiencia, el equipo de GLOBAL ACTUARIAL SERVICES le ofrece a su organización asesoría en el diseño, planeación e implementación de beneficios para empleados." />
          <Pulse>
            <CTA btnText="Conoce más" btnRoute="/nosotros" icon={<FaPlay />} />
          </Pulse>
        </Grid>
      </Grid>
    </SectionContainer>
  )
}

export default Us
